<template>
  <div id="app">

    <header id="renew2_header"
      v-if="$route.name != 'yagiprimeAdlpInterview' && $route.name != 'yagiprimeSAdlpRirekisho' && $route.name != 'okinaviPage' && $route.name != 'shogaiPage' && $site.appFlag != 'b' && !isOnlyPreview">
      <div class="menu_block renew2_wrapper">

        <div style="display: flex;align-items: flex-end;font-weight: bold;color: #004D40;">
          <h1 v-if="$globalVar.isYagiPrime && !$globalVar.isYagiPrimeCancel" id="yagiprime_member" class="h1"><a
              href="/"><img src="/static/renew3_img/yagiprime_img/logo.svg" alt="yagishブラウザでつくる履歴書・職務経歴書"></a></h1>
          <h1 v-else class="h1"><a href="/"><img src="/static/renew2_img/yagish_logo_20230522.png"
                alt="yagishブラウザでつくる履歴書・職務経歴書"></a></h1>
          <p style="font-size: 0.8rem;line-height: 1.2;"
            v-if="headerTitle == 0 && $route.params.formatId != 'rirekisho_esf_challenged'">Webで簡単<br>最短3分で履歴書作成</p>
          <p style="font-size: 0.8rem;line-height: 1.2;"
            v-else-if="headerTitle == 1 && $route.params.formatId != 'rirekisho_esf_challenged'">無料で<br>ダウンロードもできる</p>
          <p style="font-size: 0.8rem;line-height: 1.2;"
            v-else-if="headerTitle == 2 && $route.params.formatId != 'rirekisho_esf_challenged'">80%の<br>大学生や新卒が利用</p>
          <p style="font-size: 0.8rem;line-height: 1.2;" v-else-if="false">国内700万人以上<br>が利用</p>
        </div>
        <h1 class="h1" v-if="false">
          <a href="/">
            <img src="/static/renew2_img/yagish_logo_20230522.png" alt="yagishブラウザでつくる履歴書・職務経歴書">
          </a>
        </h1>
        <div class="renew2_pc">
          <ul class="renew2_flex sub_menu">
            <li class="menu_list renew2_link_toggle" v-if="getMode != 'productionX'"><a
                href="https://resume.yagish.kr/">韓国語</a></li>
            <li class="menu_list renew2_link_toggle"><a href="https://www.yagish.jp/">運営会社</a></li>
            <li class="menu_list contact renew2_link_toggle"><a href="/contact">お問い合わせ</a>
            </li>
          </ul>
          <ul class="renew2_flex menu" v-if="$route.params.formatId != 'rirekisho_esf_challenged'">
            <li class="menu_list"><a href="/">履歴書作成</a></li>
            <li v-if="false" class="menu_list"><a href="https://keirekisho.yagish.jp/">職務経歴書作成</a></li>
            <li v-if="false" class="menu_list"><a href="/yagiofferhelp">ヤギオファー</a></li>
            <li class="menu_list" v-if="false"><a href="#">求人一覧</a></li>
            <li v-if="!$firebase.isAuthenticated" class="menu_list login"><a href="/login">ログイン</a></li>
            <li v-if="!$firebase.isAuthenticated" class="menu_list register"><a href="/mregister">会員登録</a></li>
            <li v-if="$firebase.isAuthenticated && (!$globalVar.isYagiPrime || $globalVar.isYagiPrimeCancel)"
              class="menu_list renew2_mypage"><a href="/mypage" class="on_mypage"><span
                  v-if="$firebase.user.displayName">{{ $firebase.user.displayName
                  }} </span>[ {{
                    $firebase.user.email }} ]<div id="email_for_googleads" style="display:none;">{{ $firebase.user.email }}
                </div> <span class="renew2_font_small">さん</span></a>
            </li>
            <li v-if="$firebase.isAuthenticated && $globalVar.isYagiPrime && !$globalVar.isYagiPrimeCancel"
              class="menu_list renew2_mypage"><a href="/mypage/yagiprime" class="on_mypage"><span
                  style="position: absolute;display: inline-block;color: #fff;font-size: 0.5rem;font-weight: bold;background: #e3165c;border-radius: 50%;width: 16px;height: 16px;text-align: center;line-height: 2.1;top: -10px;left: -18px">{{
                    csCount }}</span><span v-if="$firebase.user.displayName">{{
                    $firebase.user.displayName
                  }} </span>[ {{
                    $firebase.user.email }} ]<div id="email_for_googleads" style="display:none;">{{ $firebase.user.email }}
                </div> <span class="renew2_font_small">さん</span></a>
            </li>
          </ul>
          <ul class="renew2_flex menu" v-else>
            <li v-if="$firebase.isAuthenticated" class="menu_list renew2_mypage"><a href="/mypage"
                class="on_mypage"><span v-if="$firebase.user.displayName">{{ $firebase.user.displayName }} </span>[ {{
                  $firebase.user.email }} ]<div id="email_for_googleads" style="display:none;">{{ $firebase.user.email }}
                </div> <span class="renew2_font_small">さん</span></a></li><!--登録メールアドレス-->
          </ul>
        </div>
        <div class="renew2_sp">
          <ul v-if="!$firebase.isAuthenticated" class="renew2_flex renew2_sp_flex sp_loginbtn"
            style="margin-right: 40px;">
            <li class="sp_menu_list"><a href="/login">ログイン</a></li>
            <li class="sp_menu_list"><a href="/mregister">会員登録</a></li>
          </ul>
          <div v-if="$firebase.isAuthenticated && (!$globalVar.isYagiPrime || $globalVar.isYagiPrimeCancel)"
            class="renew2_mypage">
            <a href="/mypage" class="on_mypage"><span v-if="getName">{{ getName }} </span><span
                class="renew2_font_small">さん</span></a>
          </div>
          <div v-if="$firebase.isAuthenticated && $globalVar.isYagiPrime && !$globalVar.isYagiPrimeCancel"
            class="renew2_mypage">
            <a href="/mypage/yagiprime" class="on_mypage"><span
                style="position: absolute;display: inline-block;color: #fff;font-size: 0.5rem;font-weight: bold;background: #e3165c;border-radius: 50%;width: 16px;height: 16px;text-align: center;line-height: 2.1;top: -10px;left: -18px">{{
                  csCount }}</span><span v-if="getName">{{ getName }} </span><span class="renew2_font_small">さん</span></a>
          </div>
          <div class="renew_hamburgermenu-container" v-if="$site.appFlag != 'b'">
            <input type="checkbox" id="overlay-input" />
            <label for="overlay-input" id="overlay-button"><span></span></label>

            <!--ハンバーガーメニュー内-->
            <div id="renew_hamburgermenu" class="renew_hamburgermenu">
              <div class="clear">
                <!--マイカード-->
                <div class="member_card" v-if="$firebase.isAuthenticated">
                  <div class=" renew2_flex renew2_sp_flex mc01">
                    <div class="member_card_left">
                      <div class="left01">
                        <p v-if="!$globalVar.isYagiPrime && !$globalVar.isYagiPrimeCancel"><a href="/yagiprime_register"
                            id="prime-mypagetop-btn" class="status">一般会員（ヤギプライム会員になる）</a>
                        </p>
                        <p v-else-if="$globalVar.isYagiPrime && $globalVar.isYagiPrimeCancel"><a
                            href="/mypage/yagiprime" class="status">一般会員（ヤギプライム解約手続き済）</a>
                        </p>
                        <p v-else><a href="/mypage/yagiprime" class="status">ヤギプライム会員</a>
                        </p>
                        <p class="name"><span v-if="getName">{{ getName }}
                          </span><span v-else>{{ $firebase.user.email }}</span> さん</p>
                        <p>（ <span>{{ $firebase.user.email }}</span> ）</p>
                      </div><!----><!---->
                    </div>
                    <div class="member_card_right yagi_info">
                      <div class="dialogEnabled messageEnabled">
                        <your-yagi :your-yagi-class="{}"
                          :yagi-options="{ dialogEnabled: true, rubyEnabled: false, messageEnabled: true }"></your-yagi>
                      </div>
                      <p class="your-yagi-title">あなたのヤギ</p>
                    </div>
                  </div>
                  <div class="mc02">
                    <a href="/mypage" class="mp-link">マイページ</a>
                  </div>
                </div>
                <div class="member_card" style="height: auto;" v-else>
                  <p style="text-align: center;font-weight: bold;">＼無料で会員登録／</p>
                  <div class="mc02" style="">
                    <a href="/mregister" class="mp-link" style="margin-bottom: 10px;">会員登録</a>
                    <a href="/login" class="mp-link" style="">ログイン</a>
                  </div>
                </div>
                <!--サービスリンク-->
                <div class="servicelink">
                  <div class="renew2_flex renew2_sp_flex servicelink-item">
                    <h4 class="sl-h4">つくる</h4>
                    <ul class="sl-list">
                      <li><a href="" class="sl-link">履歴書</a></li>
                      <li><a href="/format/shokumukeirekisho" class="sl-link">職務経歴書</a></li>
                      <li><a href="/format/letter" class="sl-link">送付状</a></li>
                    </ul>
                  </div>
                  <div class="renew2_flex renew2_sp_flex servicelink-item">
                    <h4 class="sl-h4">おくる</h4>
                    <ul class="sl-list">
                      <li><a href="/yagiprimequickmail/info" class="sl-link">郵送依頼（ヤギの宅配便）</a></li>
                      <li><a href="/yagiprimequickemail/info" class="sl-link">メール送信（ヤギのメール便）</a></li>
                    </ul>
                  </div>
                </div>

                <!--各種リンク-->
                <div class="otherlink">
                  <ul class="renew2_flex renew2_sp_flex ol-item ol-item01">
                    <li class="ol-list"><a href="/help" target="_blank" class="ol-link" id="test">よくある質問</a></li>
                    <li class="ol-list"><a href="/info" target="_blank" class="ol-link">使いかた</a></li>
                  </ul>
                  <ul class="renew2_flex renew2_sp_flex ol-item ol-item02">
                    <li class="ol-list"><a href="/terms" target="_blank" class="ol-link">利用規約</a></li>
                    <li class="ol-list"><a href="https://www.yagish.jp/privacy/" target="_blank"
                        class="ol-link">個人情報保護方針</a>
                    </li>
                    <li class="ol-list"><a href="https://www.yagish.jp/company/" target="_blank"
                        class="ol-link">運営会社について</a>
                    </li>
                    <li class="ol-list"><a href="/contact" target="_blank" class="ol-link">お問い合わせ</a></li>
                  </ul>
                </div>

                <p class="hm-copyright">©2021-2024 Yagish Co., Ltd. All rights reserved.</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </header>


    <div style="text-align: center; " v-if="$firebase.isAuthenticated && $globalVar.in_app_payments">
      <a href="/yagiprime_superagent" v-if="randomNumber == 0"
        style="background: #FFF6B4;display: block;color: #004D40;padding: 5px 0; ">ヤギプライムなら、<span
          style="font-weight: bold;">充実した就活支援！</span> ▷</a>
      <a href="/ai/interview_practice" v-else
        style="background: #FFF6B4;display: block;color: #004D40;padding: 5px 0; ">ヤギプライムなら、<span
          style="font-weight: bold;">AIと面接の練習ができる！</span> ▷</a>
    </div>

    <router-view></router-view>

    <button type="button" class="el-button el-button--primary" @click="goBack" v-if="!isTopPage && $site.appFlag == 'b'"
      style="background: #fff;color: #e3165c;position: fixed;bottom: 30px;left: 10px;z-index: 90;"><!----><!----><span><i
          class="el-icon-d-arrow-left"></i>もどる</span></button>

    <footer id="renew2_footer" v-if="$site.appFlag != 'b' && !isOnlyPreview">
      <div class="renew2_footer">
        <div class="renew2_wrapper footer_block">
          <div class="renew2_flex link_block">
            <div class="link_block__list">
              <img src="/static/renew2_img/logo.svg" alt="ヤギッシュ">
              <p class="renew2_font_small">yagish（ヤギッシュ）は、ブラウザ上で履歴書がつくれる無料サービスです。</p>
              <a href="/contact" class="contact_link renew2_link_toggle">お問い合わせ</a>
            </div><!--ロゴ-->
            <div class="link_block__container renew2_flex">
              <ul class="link_block__list margin">
                <li><a href="/">履歴書作成</a></li>
                <li v-if="false"><a href="https://keirekisho.yagish.jp/">職務経歴書作成</a></li>
                <li><a href="#" v-if="false">求人一覧</a></li>
                <li v-if="false"><a href="/yagiofferhelp">ヤギオファー</a></li>
                <li><a href="/info">yagishの使い方</a></li>
              </ul><!--リンクリスト1-->
              <ul class="link_block__list">
                <li><a href="https://www.yagish.jp/" target="_blank">運営会社</a></li>
                <li><a href="https://www.yagish.jp/recruit/" target="_blank">yagish採用</a></li>
                <li><a href="https://www.yagish.jp/privacy/" target="_blank">個人情報保護方針</a></li>
                <li><a href="https://www.yagish.jp/privacy_policy/" target="_blank">プライバシーポリシー</a></li>
                <li><a href="/law" target="_blank">特定商取引法に基づく表示</a></li>
                <li><a href="/terms">利用規約</a></li>
                <li><a href="/help">よくある質問</a></li>
              </ul><!--リンクリスト2-->
              <!--<ul class="link_block__list">
                          <li><a href="">サイトマップ</a></li>
                      </ul>リンクリスト3-->
            </div>
          </div>
          <div class="service_block">
            <p class="service_block__title">サービス一覧</p>
            <div class="renew2_flex service_block__list">
              <ul class="service_block__item">
                <li><a href="/">履歴書</a></li>
                <li><a href="https://www.yagish.jp/service/daigakuyagish/" target="_blank">各大学専用履歴書</a></li>
                <li v-if="false"><a href="#" v-if="false">求人一覧</a></li>
                <li v-if="false"><a href="https://portal.yagish.jp/company/presidents-style/" target="_blank">社長の流儀</a>
                </li>
              </ul><!--リンクリスト1-->
              <ul class="service_block__item">
                <li v-if="false"><a href="/yagiofferhelp">ヤギオファー</a></li>
                <li><a href="/quickmailhelp">ヤギの宅配便</a></li>
                <li><a href="/quickemailhelp">ヤギのメール便</a></li>
                <li><a href="/fontservicehelp">フォントサービス</a></li>
                <li><a href="/yagiprimeinfo">ヤギプライム</a></li>
              </ul><!--リンクリスト2-->
              <!--<ul class="service_block__item">https://www.yagish.jp/service/daigakuyagish/
                        <li><a href="">退職代行</a></li>
                        <li><a href="">赤ペン人事部長</a></li>
                    </ul>リンクリスト3-->

              <ul class="service_block__item bnr_item"><!---->
                <li><a href="https://line.me/S/sticker/25186829" target="_blank"><img
                      src="/static/renew2_img/bnr_linestamp.png"></a></li>
              </ul>
              <ul class="service_block__item bnr_item"><!---->
                <li><a href="https://line.me/S/emoji/?id=6583aab3896d8c165266159e" target="_blank"><img
                      src="/static/renew2_img/bnr_lineemoji.png"></a></li>
              </ul>

            </div>
          </div>
        </div>
        <div v-if="getMode != 'productionX'" class="renew2_flex renew2_sp_flex" style="
              justify-content: center;
              margin-top: 10px;">
          <a href="" target="_blank" style="
              margin-right: 15px;
              color: #fff;
              font-weight: bold;" v-if="false">日本語</a>
          <a href="https://resume.yagish.kr/" target="_blank" style="
              color: #fff;
              font-weight: bold;">韓国語</a>
        </div>
        <p class="copyright">©2021-2024 Yagish Co., Ltd. All rights reserved.</p>
      </div>
    </footer>


    <account-dialog />
    <introduction-dialog />
    <all-preview-dialog />
    <yagioffer-dialog />
    <joblist-dialog />
    <loginform-dialog />
    <fontpayment-dialog />
    <yagiprimefontpayment-dialog />
    <carat-dialog />
    <yagioffer-special-dialog />

  </div>
</template>


<style lang="scss" src="@/assets/scss/style.scss"></style>
<style lang="css" src="@/assets/css/renew_reset.css"></style>
<style lang="css" src="@/assets/css/renew_stylesheet.css"></style>
<style lang="css" src="@/assets/css/renew_animation.css"></style>
<style lang="css" src="@/assets/css/renew_tab.css"></style>
<style lang="css" src="@/assets/css/renew_add.css"></style>

<style lang="css" src="@/assets/css/renew2_style.css"></style>
<style lang="css" src="@/assets/css/renew2_login.css"></style>
<style lang="scss" scoped>
.service_block__list .bnr_item img {
  width: 234px;
  height: 75px;
}

@media screen and (max-width: 640px) {
  #renew2_footer .service_block__list .bnr_item {
    margin-right: 0;
    margin: 20px 0;
  }

  #renew2_footer .service_block__list .bnr_item img {
    width: 100%;
    height: auto;
  }
}
</style>

<style>
#renew2_header .renew2_mypage {
  margin-right: 50px;
}

#overlay-button {
  position: absolute;
  right: 0;
  top: -7px;
  padding: 26px 11px;
  z-index: 5;
  cursor: pointer;
  user-select: none;
  opacity: 1;
}

#overlay-button span {
  height: 4px;
  width: 35px;
  border-radius: 2px;
  background-color: #8fbd67;
  position: relative;
  display: block;
  transition: all .2s ease-in-out;
}

#overlay-button span:before {
  top: -10px;
  visibility: visible;
}

#overlay-button span:after {
  top: 10px;
}

#overlay-button span:before,
#overlay-button span:after {
  height: 4px;
  width: 25px;
  border-radius: 2px;
  background-color: #8FBD67;
  position: absolute;
  content: "";
  transition: all .2s ease-in-out;
}

#overlay-button:hover span,
#overlay-button:hover span:before,
#overlay-button:hover span:after {
  background: #8FBD67;
}

input[type=checkbox] {
  display: none;
}

input[type=checkbox]:checked~#renew_hamburgermenu {
  visibility: visible;
}

input[type=checkbox]:checked~#overlay-button:hover span,
input[type=checkbox]:checked~#overlay-button span {
  background: transparent;
}

input[type=checkbox]:checked~#overlay-button span:before {
  transform: rotate(45deg) translate(7px, 7px);

}

input[type=checkbox]:checked~#overlay-button span:after {
  transform: rotate(-45deg) translate(7px, -7px);
}

#renew_hamburgermenu a {
  -webkit-transition: 0s;
  transition: 0s;
}

#renew_hamburgermenu a:hover {
  text-decoration: none;
  font-weight: bold;
  opacity: 1;
}

#renew_hamburgermenu {
  position: fixed;
  width: 100vw;
  /* margin-top: 35px; */
  background: #fff;
  background-image: url(/static/renew2_img/hm-back.png);
  background-position: bottom;
  background-size: cover;
  z-index: 99;
  visibility: hidden;
  left: 0;
  right: 0;
  animation: bugfix infinite 1s;
  -webkit-animation: bugfix infinite 1s;
}

@keyframes bugfix {
  from {
    padding: 0;
  }

  to {
    padding: 0;
  }
}

@-webkit-keyframes bugfix {
  from {
    padding: 0;
  }

  to {
    padding: 0;
  }
}

.renew_hamburgermenu .clear {
  /* padding: 0 10px 10px; */
  padding: 20px 10px 10px;
  background-color: rgba(255, 255, 255, 0.6);
  border-top: 1px solid #fff;
}

.renew_hamburgermenu .member_card {
  background: #8fbd67;
  color: #fff;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  height: 200px;
}

.renew_hamburgermenu .mc01 {
  align-items: center;
}

.renew_hamburgermenu .mp-link {
  position: relative;
  display: block;
  width: 100%;
  text-align: center;
  padding: 5px 0;
  font-weight: bold;
  color: #0F9934;
  font-size: 14px;
  background: #fff;
  border-radius: 50px;
}

.renew_hamburgermenu .mp-link::after {
  content: "";
  width: 7px;
  height: 7px;
  border: 0;
  border-bottom: 2px solid #0f9934;
  border-right: 2px solid #0f9934;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  position: absolute;
  top: 0;
  right: 15px;
  bottom: 0;
  margin: auto;
}

.renew_hamburgermenu .member_card_left {
  width: 75%;
}

.renew_hamburgermenu .left01 {
  margin-bottom: 30px;
}

.renew_hamburgermenu .status {
  display: inline-block;
  color: #404040;
  font-size: .7rem;
  background: #fff;
  border-radius: 30px;
  border: 2px solid #fff;
  padding: 3px 10px;
  margin-bottom: 10px;
}

.renew_hamburgermenu .name {
  font-size: 1rem;
  font-weight: 700;
}

.renew_hamburgermenu .name span {
  font-size: 1.2rem;
}

.renew_hamburgermenu .member_card_right {
  width: 25%;
  text-align: center;
}

.renew_hamburgermenu .your-yagi-title {
  font-size: 0.7rem;
}

.renew_hamburgermenu .sl-h4 {
  color: #0F9934;
  font-size: 14px;
  line-height: 2.2;
}

.renew_hamburgermenu .servicelink {
  margin-bottom: 20px;
}

.renew_hamburgermenu .servicelink-item {
  justify-content: space-between;
  padding: 20px;
}

.renew_hamburgermenu .servicelink-item:first-child {
  border-bottom: 1px solid #DFDFDF;
  padding: 0 20px 20px;
}

.renew_hamburgermenu .sl-list {
  width: calc(100% - 80px);
  line-height: 2.2;
}

.renew_hamburgermenu .sl-link {
  position: relative;
  display: block;
  width: 100%;
}

.renew_hamburgermenu .sl-link::after {
  content: "";
  width: 7px;
  height: 7px;
  border: 0;
  border-bottom: 2px solid #0f9934;
  border-right: 2px solid #0f9934;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  position: absolute;
  top: 0;
  right: 15px;
  bottom: 0;
  margin: auto;
}

.renew_hamburgermenu .otherlink {
  margin-bottom: 30px;
}

.renew_hamburgermenu .ol-item {
  flex-wrap: wrap;
  justify-content: space-between;
}

.renew_hamburgermenu .ol-list {
  width: calc(100% / 2 - 5px);
  font-size: 12px;
}

.renew_hamburgermenu .ol-item01 {
  margin-bottom: 20px;
}

.renew_hamburgermenu .ol-item01 .ol-link {
  position: relative;
  display: block;
  width: 100%;
  background: #0F9934;
  border-radius: 50px;
  color: #fff;
  font-weight: bold;
  font-size: 14px;
  text-align: center;
  padding: 10px 0;
  overflow: hidden;
  z-index: 1;
}

.renew_hamburgermenu .ol-item01 .ol-link:after {
  background: #004D40;
  position: absolute;
  top: 0;
  left: 0;
  content: '';
  width: 100%;
  height: 100%;
  transform: scale(0, 1);
  transform-origin: left top;
  transition: .2s cubic-bezier(0.45, 0, 0.55, 1);
  z-index: -1;
}

.renew_hamburgermenu .ol-item01 .ol-link:hover::after {
  transform: scale(1, 1);
}

.renew_hamburgermenu .hm-copyright {
  font-size: 10px;
  text-align: center;
}
</style>

<script>

import AccountDialog from '@/components/AccountDialog'
import IntroductionDialog from '@/components/IntroductionDialog'
import AllPreviewDialog from '@/components/AllPreviewDialog'
import YagiOfferDialog from '@/components/YagiOfferDialog'
import JoblistDialog from '@/components/JobListDialog'
import LoginFormDialog from '@/components/LoginFormDialog'
import YagiprimeFontPaymentDialog from '@/components/YagiprimeFontPaymentDialog'
import FontPaymentDialog from '@/components/FontPaymentDialog'
import CaratDialog from '@/components/CaratDialog20240801'
import YagiofferSpecialDialog from '@/components/YagiofferSpecialDialog'

export default {
  props: {
    isLight: {
      type: Boolean
    }
  },
  components: {
    'account-dialog': AccountDialog,
    'introduction-dialog': IntroductionDialog,
    'all-preview-dialog': AllPreviewDialog,
    'yagioffer-dialog': YagiOfferDialog,
    'joblist-dialog': JoblistDialog,
    'loginform-dialog': LoginFormDialog,
    'fontpayment-dialog': FontPaymentDialog,
    'yagiprimefontpayment-dialog': YagiprimeFontPaymentDialog,
    'carat-dialog': CaratDialog,
    'yagioffer-special-dialog': YagiofferSpecialDialog
  },
  data: function () {
    return {
      headerTitle: 0,
      csCount: 0,
      randomNumber: 0
    }
  },
  methods: {
    goBack() {
      window.history.back();
    },
    checkMynabi: function () {
      if (this.$route.query.mynavi === '19xs#rrdfS234') {
        this.$yagi.isFromMynabi = 1
      }
    },
    authStateChanged: async function () {
      console.error(this.$firebase.user.uid)
      const app = this
      this.$axios
        .get(this.$varuna.endPoints.isSubscribed + this.$firebase.user.uid + '/', null, { timeout: 60000 })
        .then(function (response) {
          app.$globalVar.isYagiPrime = response.data.is_subscribed
          app.$globalVar.isYagiPrimeCancel = response.data.is_cancel
          if (response.data.is_subscribed) {
            const formData = new FormData()
            formData.append('uuid', app.$firebase.user.uid)

            app.$axios
              .post(app.$varuna.endPoints.subscriptionsMypage, formData, { timeout: 60000 })
              .then(function (response) {
                console.error(response.data)
                let _joblist = response.data.recommended_jobs

                for (let _key in _joblist) {
                  let _job = _joblist[_key]
                  if (!_job.read_date) {
                    app.csCount++
                    console.error(_job.read_date)

                  }

                }
              })
              .catch(function (error) {
              }).finally(function () {
                app.fullscreenLoading = false
              })
          }
        })
        .catch(function (error) {
        }).finally(function () {
        })
    }
  },
  computed: {
    getName: function () {
      if (this.$firebase.user && this.$firebase.user.displayName) {
        return this.$firebase.user.displayName
      } else {
        if (this.$firebase.user && this.$firebase.user.email) {
          return this.$firebase.user.email.split('@')[0]
        } else {
          return 'ヤギ'
        }
      }
    },
    logoBaseStyle: function () {
      if (process.env.VUE_APP_MODE === 'production') {
        return {
          fill: '#fff'
        }
      } else if (process.env.VUE_APP_MODE === 'staging') {
        return {
          fill: '#6bff38'
        }
      } else {
        return {
          fill: '#cc38ff'
        }
      }
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    },
    logoEyeStyle: function () {
      if (process.env.VUE_APP_MODE === 'production') {
        return {
          fill: '#e91044'
        }
      } else if (process.env.VUE_APP_MODE === 'staging') {
        return {
          fill: '#09bc6c'
        }
      } else {
        return {
          fill: '#fff'
        }
      }
    },
    isTopPage: function () {
      return (this.$route.name === 'top')
    },
    isOnlyPreview: function () {
      return (this.$route.name === 'previewOnly') || (this.$route.query.noheader === '1')
    },
    isMynabi: function () {
      this.checkMynabi()
      return (this.$yagi.isFromMynabi === 1)
    },
    isEditingFormat: function () {
      return (this.$route.name === 'formatEditCard')
    },
    needsFullScreen: function () {
      return (this.$route.name === 'formatPreview')
    },
    needsFooter: function () {
      if (this.$route.name === 'formatPreview' || this.$route.name === 'formatEditCard') {
        return false
      }
      return true
    }
  },
  created: function () {

    console.error(this.$route.fullPath)
    console.error(this.$route.params.formatId)
    const nowdate = new Date()
    let dayOfWeek = nowdate.getDay()
    this.headerTitle = nowdate.getDate() % 4
    const app = this
    this.headerTitle = 99

    const formData = new FormData()
    formData.append('app_flag', this.$site.appFlag)
    this.$axios
      .post(this.$varuna.endPoints.siteSetting, formData, { timeout: 60000 })
      .then(function (response) {
        if (response.data.in_app_payments == 0) {
          app.$globalVar.in_app_payments = false
        }
      })
      .catch(function (error) {
      }).finally(function () {
      })

  },
  beforeMount: function () {
    if (Math.floor(Math.random() * 2) == 0) {
      this.randomNumber = 0
    } else {
      this.randomNumber = 1
    }
    this.$eventHub.$on('firebase-initialized', this.authStateChanged)
  },
  destroyed: function () {
    this.$eventHub.$off('firebase-initialized', this.authStateChanged)
  }
}
</script>
